import { FooterLink, FooterLinkProps } from './footer-link';

interface BottomLinksProps {
  items: FooterLinkProps[];
}

export const BottomLinks = ({ items }: BottomLinksProps) => (
  <ul className="flex gap-y-3 gap-x-10 justify-center flex-wrap">
    {items.map(({ href, name }) => (
      <li key={name} className="pe-2 flex items-center">
        <FooterLink name={name} href={href} />
      </li>
    ))}
  </ul>
);
